module.exports = __webpack_public_path__ + "static/img/jgcl_banner_text.8600bd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activityforecast2024/jgcl_banner_text.png
// module id = a/r0
// module chunks = 0